var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.652,
    height: 12.69,
    viewBox: "0 0 12.652 12.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M12.037,11.491,8.9,8.4a4.964,4.964,0,0,0,1.326-3.372A5.073,5.073,0,0,0,5.113,0,5.072,5.072,0,0,0,0,5.031a5.072,5.072,0,0,0,5.113,5.031A5.143,5.143,0,0,0,8.331,8.939l3.15,3.1a.4.4,0,0,0,.556,0,.383.383,0,0,0,0-.548m-6.924-2.2A4.292,4.292,0,0,1,.787,5.031,4.292,4.292,0,0,1,5.113.774,4.292,4.292,0,0,1,9.439,5.031,4.292,4.292,0,0,1,5.113,9.288",
    transform: "translate(0.25 0.25)",
    fill: "#4b4b4c",
    stroke: "#4b4b4c",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1677189fd0c4cfe36679d8ce0eea47b3.svg";
export { ForwardRef as ReactComponent };